import produce from 'immer'
import { assign, stubFalse } from 'lodash'

import { createTreeSelectOptions } from '../../helpers'
import { COMMON_FETCH_CUISINE_TYPES } from '../action-types'
import { CUISINE_TYPES_INITIAL_STATE } from '../initial-states'

const cuisineTypesReducer = (state = CUISINE_TYPES_INITIAL_STATE, action) => {
  switch (action.type) {
    case COMMON_FETCH_CUISINE_TYPES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_CUISINE_TYPES.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: action.payload.data.cuisineTypes.results,
          options: createTreeSelectOptions(
            action.payload.data.cuisineTypes.results,
            'name',
            'id',
            stubFalse,
          ),
        }),
      )

    case COMMON_FETCH_CUISINE_TYPES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_CUISINE_TYPES.CLEANUP:
      return { ...CUISINE_TYPES_INITIAL_STATE }

    default:
      return state
  }
}

export default cuisineTypesReducer
